import React from 'react';
import { PRIORITIES, TEMP_LEVELS } from './constantes';

const fmt = v => v != null ? 'R$ '+Number(v).toLocaleString('pt-BR',{minimumFractionDigits:2}) : '—';

const fmtDateOnly = s => { if(!s) return '—'; const [y,m,d]=s.split('-'); return `${d}/${m}/${y}`; };

function fmtWhatsApp(phone) {
  const d = (phone||'').replace(/\D/g,'');
  if (!d) return null;
  if (d.startsWith('55') && d.length >= 12) return d;
  return '55' + d;
}

function getRecMonths(key) {
  if (!key || key === 'unica') return 1;
  if (key.endsWith('m')) return parseInt(key) || 1; // legado: '3m','6m','12m'
  const n = parseInt(key);
  return isNaN(n) ? 1 : n;
}

// Retorna label legível da recorrência

function getRecLabel(key) {
  if (!key) return '—';
  if (key === 'unica') return 'Execução única';
  const m = getRecMonths(key);
  return `${m} ${m === 1 ? 'mês' : 'meses'} de contrato`;
}

// ─── Ícones de navegação ──────────────────────────────────
// Traço de 1.7 para casar com o peso do texto. SF Symbols não pode
// ser redistribuído fora de app Apple, então usamos desenho próprio.

function calcContractTotal(value, recurrence) {
  if (!value || !recurrence || recurrence === 'unica') return Number(value)||0;
  return (Number(value)||0) * getRecMonths(recurrence);
}

// ─── Utilitários ──────────────────────────────────────────

function normalizeUrl(raw) {
  const s = (raw || '').trim();
  if (!s) return null;
  if (/^(javascript|data|vbscript|file):/i.test(s)) return null;
  if (/^https?:\/\//i.test(s)) return s;
  return 'https://' + s.replace(/^\/+/, '');
}

/**
 * Guarda o Instagram sempre como o @ puro, venha como vier: "@fulano", "fulano",
 * "instagram.com/fulano" ou a URL inteira com parâmetros. Sem isso o mesmo perfil
 * entra de três jeitos diferentes e não dá para comparar nem montar link.
 */
function normalizeInstagram(raw) {
  let s = String(raw || '').trim();
  if (!s) return null;
  s = s.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
  s = s.replace(/^instagram\.com\//i, '');
  s = s.split(/[/?#]/)[0];           // corta caminho, query e âncora
  s = s.replace(/^@+/, '').trim();
  // O Instagram só aceita letra, número, ponto e underline, até 30 caracteres.
  if (!/^[A-Za-z0-9._]{1,30}$/.test(s)) return null;
  return s;
}

// Calcula valor total do contrato (mensal × meses da recorrência)

function genToken(len=14) {
  const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  let t = '';
  for (let i=0; i<len; i++) t += chars[Math.floor(Math.random()*chars.length)];
  return t;
}

function getDateStatus(dateStr) {
  if (!dateStr) return null;
  const today = new Date(); today.setHours(0,0,0,0);
  const d = new Date(dateStr+'T00:00:00');
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0)  return { status:'overdue', diff, label:`${Math.abs(diff)}d atraso`, cls:'bg-red-100 text-red-700 border border-red-300' };
  if (diff === 0) return { status:'today',  diff, label:'Hoje',                       cls:'bg-orange-100 text-orange-700 border border-orange-300' };
  if (diff <= 7)  return { status:'soon',   diff, label:`em ${diff}d`,                cls:'bg-blue-100 text-blue-700 border border-blue-300' };
  return           { status:'future', diff, label:fmtDateOnly(dateStr),           cls:'bg-gray-100 text-gray-500 border border-gray-200' };
}

// ─── Computação de KPIs (client-side) ────────────────────

const getPrio = key => PRIORITIES.find(p=>p.key===key) || PRIORITIES[1];

function getTempLevel(v) { return TEMP_LEVELS.find(t=>t.v===v) || null; }

/**
 * Soma dias a uma data e devolve YYYY-MM-DD no fuso local.
 * `toISOString()` vira o dia seguinte depois das 21h no Brasil; numa cadência
 * o erro se acumula a cada ciclo, então a conta é feita em horário local.
 * base: 'YYYY-MM-DD' ou vazio (hoje).
 */
function addDaysISO(base, days) {
  const d = base ? new Date(base + 'T00:00:00') : new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + (Number(days) || 0));
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Preenche {nome} {empresa} {vendedor} {nossa} numa mensagem de WhatsApp. */
function renderWaTemplate(text, lead, nossa) {
  const primeiro = (v) => String(v || '').trim().split(/\s+/)[0] || '';
  return String(text || '')
    .replace(/\{nome\}/g, primeiro(lead?.contact_name) || primeiro(lead?.company_name))
    .replace(/\{empresa\}/g, String(lead?.company_name || '').trim())
    .replace(/\{vendedor\}/g, primeiro(lead?.seller_name))
    .replace(/\{nossa\}/g, String(nossa || '').trim())
    .replace(/ ,/g, ',').replace(/\s{2,}/g, ' ').trim();
}

/** Link do WhatsApp; com texto, já abre com a mensagem escrita. */
function waLink(wa, text) {
  return text ? `https://wa.me/${wa}?text=${encodeURIComponent(text)}` : `https://wa.me/${wa}`;
}

export { addDaysISO, calcContractTotal, fmt, fmtDateOnly, fmtWhatsApp, genToken, getDateStatus, getPrio, getRecLabel, getRecMonths, getTempLevel, normalizeInstagram, normalizeUrl, renderWaTemplate, waLink };
